import { PocThemeProvider } from 'commons/components/components-wrapper';
import { APP_THEME } from 'core/theme/theme.config';
import { QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from 'core/auth/providers/auth.provider';
import { AppGlobalProvider } from 'core/contexts/app.provider.context';
import { FeatureFlagsProvider } from 'core/contexts/feature-flags/providers/feature-flags.provider';
import { OidcAuthProvider } from 'core/providers/oidc-auth.provider';
import { PopupExtendedProvider } from 'core/providers/popup-extended.provider';
import { queryClient } from 'core/query-client/query-client';
import { i18n, I18nextProvider } from 'core/i18n/i18n';
import React, { useState } from 'react';

export const AppProviders: React.FC<React.PropsWithChildren> = ({ children }) => {
    const [theme] = useState(APP_THEME);

    return (
        <OidcAuthProvider>
            <AuthProvider>
                <QueryClientProvider client={queryClient}>
                    <FeatureFlagsProvider>
                        <AppGlobalProvider>
                            <I18nextProvider i18n={i18n}>
                                <PocThemeProvider theme={theme}>
                                    <PopupExtendedProvider>{children}</PopupExtendedProvider>
                                </PocThemeProvider>
                            </I18nextProvider>
                        </AppGlobalProvider>
                    </FeatureFlagsProvider>
                </QueryClientProvider>
            </AuthProvider>
        </OidcAuthProvider>
    );
};
